/*
  Vaelger kunden ÉN vaerdi i et filter der har sin egen side, sendes de dertil
  i stedet for at blive paa den filtrerede URL.

  Hvorfor det ikke bare er pynt: den filtrerede URL baerer en canonical mod den
  ufiltrerede kollektion. Google laegger altsaa al vaegt paa /collections/hudpleje,
  og en filtreret visning kan aldrig selv rangere. /collections/serum kan, den
  har 900 ord tekst og en overskrift der matcher hensigten. Uden det her sender
  vores eget UI kunden til den daarligste af de to sider, mens vores egne
  tekster linker til den bedste.

  Fire ting er vaerd at vide, hvis nogen skal rette i det her:

  1. facets.js lytter paa `input` paa formen og er DEBOUNCET med 500 ms. Vi
     lytter i CAPTURE-fasen paa document, saa vi naar frem foerst og kan stoppe
     haendelsen med stopPropagation. Gjorde vi det i bubble-fasen, ville
     filtreringen naa at blive planlagt, og siden ville baade filtrere og
     navigere.

  2. Kortene ligger i JSON-script-tags bygget af Liquid. Produkttypen udledes af
     varerne selv; hudbehov kan ikke, fordi metafeltet er en LISTE og den
     foerste vare i en kollektion typisk har flere vaerdier. Hudbehov staar
     derfor i en setting.

  3. Raekkefoelgen betyder noget. Produkttype vinder over hudbehov: har kunden
     valgt baade Serum og Toer hud, er serum-siden den mest praecise, og
     hudbehovet foelger med som filter.

  4. URL'en i adresselinjen roeres ikke ved klik. Skubbede vi ?page= eller
     filtrene ind, ville en genindlaesning vise noget andet end det kunden ser.
*/
(function () {
  'use strict';

  // raekkefoelge = prioritet
  // Raekkefoelgen er prioritet, og den er valgt efter hvor praecist siden
  // svarer paa hensigten. Produkttype er mest praecist ("jeg skal have et
  // serum"), hudbehov naest ("jeg har toer hud"), brand sidst ("vis mig det
  // maerke"). Vaelger kunden Toer hud OG iS Clinical, er hudbehov-siden derfor
  // maalet, og brandet foelger med som filter.
  var FACETTER = [
    { navn: 'filter.p.product_type', kort: 'webshop-typemap' },
    { navn: 'filter.p.m.custom.hudbehov', kort: 'webshop-hudbehovmap' },
    { navn: 'filter.p.vendor', kort: 'webshop-brandmap' },
  ];

  var cache = {};

  function hentKort(id) {
    if (cache[id] !== undefined) return cache[id];
    var el = document.getElementById(id);
    try {
      cache[id] = el ? JSON.parse(el.textContent) : null;
    } catch (e) {
      console.error('[webshop-filter-nav] kunne ikke laese ' + id, e);
      cache[id] = null;
    }
    return cache[id];
  }

  function beregnMaal(data) {
    for (var i = 0; i < FACETTER.length; i++) {
      var f = FACETTER[i];
      var m = hentKort(f.kort);
      if (!m) continue;

      var valgte = data.getAll(f.navn).filter(function (v) { return v !== ''; });
      if (valgte.length !== 1) continue;      // 0 eller flere: naeste facet

      var handle = m[valgte[0]];
      if (!handle) continue;                  // vaerdien har ingen egen side

      var sti = '/collections/' + handle;
      if (window.location.pathname === sti) return null;   // vi er der allerede

      // Behold alle OEVRIGE filtre, men ikke den vi lige rejste paa.
      // `sort_by` ryger ogsaa: sortering er en visningspraeference, den nye
      // side har sin egen standard, og den ville bare laegge en query-streng
      // paa en URL vi gerne vil holde ren.
      var rest = new URLSearchParams();
      data.forEach(function (vaerdi, navn) {
        if (navn === f.navn || navn === 'sort_by' || vaerdi === '') return;
        rest.append(navn, vaerdi);
      });
      var q = rest.toString();
      return q ? sti + '?' + q : sti;
    }
    return null;
  }

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var form = t.closest('facet-filters-form form');
    if (!form) return;

    var maal;
    try {
      maal = beregnMaal(new FormData(form));
    } catch (fejl) {
      console.error('[webshop-filter-nav]', fejl);
      return;                                 // fald tilbage til normal filtrering
    }
    if (!maal) return;

    e.stopPropagation();
    window.location.assign(maal);
  }, true);
})();
